<template>
  <v-dialog v-model="dialog" max-width="600" scrollable>
    <v-card class="rounded-xl">
      <v-card-title v-if="!loading" class="px-4">
        <div class="d-flex gap-3 align-center">
          <div>
            <v-img
              :src="party?.cover"
              height="70px"
              :width="70 * (16 / 9)"
              contain
              class="rounded-lg"
            ></v-img>
          </div>
          <div class="d-flex flex-column gap-1">
            <small class="text-overline lh-1">
              {{ party?.Organization.Platform.name }}
            </small>
            <h6 class="mb-0 lh-1">{{ party?.name }}</h6>
            <p class="mb-0 text-12 lh-1">
              {{ party?.date | date("DD [de] MMMM [de] YYYY") }}
            </p>
          </div>
        </div>
      </v-card-title>
      <v-skeleton-loader v-if="loading" type="card" height="200px" />
      <v-card-text class="d-flex flex-column gap-3 align-stretch" v-else>
        <!-- Description -->
        <v-card outlined class="pa-3" rounded="lg">
          <b> Descrição</b>
          <description-wrap
            :description="party?.description"
          ></description-wrap>
        </v-card>

        <!-- Location -->
        <v-card outlined class="pa-3" rounded="lg">
          <b>Localização</b>
          <div class="d-flex gap-3 align-center">
            <div :style="bgStyle" class="rounded-lg"></div>
            <div class="d-flex flex-column">
              <template v-if="party?.locationReveled && !!party?.Address">
                <h6 class="mb-0">{{ party?.Address.name }}</h6>

                <p class="text-truncate mb-0">
                  {{ fullAddress }}
                </p>
              </template>
              <template v-else-if="!!party?.Address">
                <h6>Endereço não revelado</h6>
                <p class="text-truncate mb-0">
                  {{ fullAddress }}
                </p>
              </template>
              <template v-else>
                <h6 class="mb-0">Endereço não informado</h6>
              </template>
            </div>
          </div>
        </v-card>
      </v-card-text>
      <v-card-actions class="align-center">
        <v-btn text @click="dialog = false"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SUPPORT from "@/services/support";
import DescriptionWrap from "@/components/global/DescriptionWrap.vue";
const { VUE_APP_MAPS_KEY } = process.env;

export default {
  components: {
    DescriptionWrap,
  },
  data() {
    return {
      dialog: false,
      partyId: null,
      party: null,
      loading: false,
    };
  },
  methods: {
    async getPartyDetails() {
      try {
        this.loading = true;
        const { party } = await SUPPORT.getParty(this.partyId);
        this.party = party;
      } catch (e) {
        this.error = e.message || "Erro ao carregar detalhes da festa.";
      } finally {
        this.loading = false;
      }
    },
    open(party) {
      this.party = null;
      this.partyId = party.id;
      this.dialog = true;
      this.getPartyDetails();
    },
    close() {
      this.dialog = false;
    },
    copyContent(event) {
      const text = event.target.innerText;
      console.log(text);
      navigator.clipboard.writeText(text);
      event.target.classList.add("success--text");
      setTimeout(() => {
        event.target.classList.remove("success--text");
      }, 1000);
    },
  },
  computed: {
    geometry() {
      if (!this.party?.Address?.lat || !this.party?.Address?.lng) return null;
      return {
        lat: this.party.Address.lat,
        lng: this.party.Address.lng,
      };
    },
    bgUrl() {
      if (!!this.party?.Address) {
        const point = this.geometry
          ? `${this.geometry.lat},${this.geometry.lng}`
          : this.fullAddress;

        const url = new URL(`https://maps.googleapis.com/maps/api/staticmap`);
        url.searchParams.set("center", point);
        url.searchParams.set("zoom", this.party?.locationReveled ? "14" : "11");
        url.searchParams.set("size", "900x295");
        url.searchParams.set("key", VUE_APP_MAPS_KEY);
        if (this.party?.locationReveled)
          url.searchParams.set("markers", `color:blue|${point}`);
        if (this.$vuetify.theme.dark)
          url.searchParams.set("map_id", "63f4baff8ff4ba69");

        return `url(${url.toString()})`;
      } else
        return "url(https://firebasestorage.googleapis.com/v0/b/ticketme-2f29d.appspot.com/o/template-map.jpeg?alt=media&token=70608367-b60e-47d4-9aa0-969169d50092)";
    },
    bgStyle() {
      return {
        backgroundImage: this.bgUrl,
        height: "90px",
        width: "90px",
        backgroundPosition: "center top",
        backgroundSize: "cover",
      };
    },
    fullAddress() {
      if (!this.party?.Address) return "";
      const addrs = this.party.Address;
      var address = "";
      if (this.party.locationReveled) {
        if (addrs.street) {
          address += `${addrs.street}`;
          if (addrs.number) address += `, ${addrs.number}`;
        }
        if (addrs.neighborhood) address += ` - ${addrs.neighborhood}`;
        if (addrs.complement) address += ` - ${addrs.complement}`;
        if (address) address += ` - `;
        address += `${addrs.city} - ${addrs.state}`;
        if (addrs.zipCode) address += ` - ${addrs.zipCode}`;
      } else {
        address = `${addrs.city} - ${addrs.state}`;
      }

      return address;
    },
  },

  mounted() {
    this.$root.$on("party-details", this.open);
  },
  props: {
    data: Object,
  },
};
</script>

<style>
</style>